import React from "react";
import { useLocation } from 'react-router-dom';
import "./ProjectDetail.css";


const ProjectDetail = () => {
    const location = useLocation();
    const projectData = location.state;

    const details = projectData.highlites ? projectData.highlites.map((skill, index) => {
        return <ul key={index}>
            <li>{skill}</li>
        </ul>
    }) : [];

    const architecture = projectData.architecture;


  return (
    <main>
    <div class="mainBody">
      <div class="bannerBlock4">
        <div
          style={{
            position: "absolute",
            right: "0px",
            width: "250px",
            height: "150px",
            backgroundposition: "-0px -100px",
          }}
        >
          <img src={require("../images/Services.png")} />{" "}
        </div>
        <div class="bannerContent">
          <div class="content">
            <span class="pageTitle">{location.state.title}</span>
            <br />
            <span class="subTitle">
              {/* We are passionate about building innovative <br />
              and robust products */}
            </span>
          </div>
        </div>
      </div>

      <div className="content padSmall">
        <div class="pDesc">
           <span class="subTitle1">
                      <b>{location.state.title}</b>
             </span>

           <br></br>
            <p><b>{location.state.description}</b></p>
            <br></br>
            <br />

            {location.state.image && (
              <>
                <img src = {location.state.image} alt={location.state.title} />
                <br></br>
                <br />
              </>
            )}

            <span class="subTitle1">
                      <b>Business Impact & Key Outcomes</b>
             </span>
             <br />

            {details.length > 0 ? (
            <p> {details} </p>
          ) : (
            <p> Contact Us for More Details </p>
          )}
          <br />

          {/* Architecture Section */}
          {architecture && (
            <>
              <span class="subTitle1">
                <b>Technical Architecture</b>
              </span>
              <br />
              <br />

              <p>
                <b>Architecture Pattern:</b> {architecture.pattern}
                <br />
                <b>Deployment {architecture.regions ? "Regions" : "Region"}:</b> {architecture.regions ? architecture.regions.join(", ") : (architecture.region || "N/A")}
                <br />
                <b>Availability Zones:</b> {architecture.availabilityZones ? (Array.isArray(architecture.availabilityZones) ? architecture.availabilityZones.join(", ") : architecture.availabilityZones) : "N/A"}
              </p>
              <br />

              <span class="subTitle1" style={{ fontSize: "18px" }}>
                <b>AWS Components & Services</b>
              </span>
              <br />
              <br />

              {architecture.components && architecture.components.map((component, index) => (
                <div key={index} style={{ marginBottom: "20px" }}>
                  <p>
                    <b style={{ color: "#87CEEB" }}>{component.service}</b>
                    <br />
                    {component.purpose}
                  </p>
                </div>
              ))}
              <br />

              {architecture.dataFlow && architecture.dataFlow.length > 0 && (
                <>
                  <span class="subTitle1" style={{ fontSize: "18px" }}>
                    <b>Data Flow & Integration</b>
                  </span>
                  <br />
                  <br />
                  <ul>
                    {architecture.dataFlow.map((flow, index) => (
                      <li key={index} style={{ marginBottom: "10px" }}>{flow}</li>
                    ))}
                  </ul>
                  <br />
                </>
              )}

              {architecture.security && architecture.security.length > 0 && (
                <>
                  <span class="subTitle1" style={{ fontSize: "18px" }}>
                    <b>Security Features</b>
                  </span>
                  <br />
                  <br />
                  <ul>
                    {architecture.security.map((security, index) => (
                      <li key={index} style={{ marginBottom: "10px" }}>{security}</li>
                    ))}
                  </ul>
                  <br />
                </>
              )}

              {architecture.scalability && architecture.scalability.length > 0 && (
                <>
                  <span class="subTitle1" style={{ fontSize: "18px" }}>
                    <b>Scalability & Performance</b>
                  </span>
                  <br />
                  <br />
                  <ul>
                    {architecture.scalability.map((scale, index) => (
                      <li key={index} style={{ marginBottom: "10px" }}>{scale}</li>
                    ))}
                  </ul>
                  <br />
                </>
              )}

              {architecture.infrastructureManagement && architecture.infrastructureManagement.length > 0 && (
                <>
                  <span class="subTitle1" style={{ fontSize: "18px" }}>
                    <b>Infrastructure Management</b>
                  </span>
                  <br />
                  <br />
                  <ul>
                    {architecture.infrastructureManagement.map((infra, index) => (
                      <li key={index} style={{ marginBottom: "10px" }}>{infra}</li>
                    ))}
                  </ul>
                  <br />
                </>
              )}

              {architecture.governance && architecture.governance.length > 0 && (
                <>
                  <span class="subTitle1" style={{ fontSize: "18px" }}>
                    <b>Governance & Compliance</b>
                  </span>
                  <br />
                  <br />
                  <ul>
                    {architecture.governance.map((gov, index) => (
                      <li key={index} style={{ marginBottom: "10px" }}>{gov}</li>
                    ))}
                  </ul>
                  <br />
                </>
              )}
            </>
          )}

        </div>
          <br />
        </div>
        <br />

    </div>
    <div style={{ clear: "both" }}></div>
  </main>
  );
};

export default ProjectDetail;
